// extracted by mini-css-extract-plugin
export var darkMode = "_17-0";